import React from "react";

const BlogsHero = () => {
  return (
    <div className=" flex justify-center">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-8">
        {/* Blog post cards will go here */}
        <div className=" space-y-2 md:space-y-4 lg:space-y-6 xl:space-y-12">
          <h1 className=" text-5xl xl:text-6xl 2xl:text-7xl font-bold text-black">
            Blogs
          </h1>
          <div className="space-y-4 xl:space-y-12">
            <h2 className="mt-4 text-black text-3xl 2xl:text-4xl font-bold">
              The Future of Physical Retail Branding is Here
            </h2>
            <p className="text-gray-600 text-base lg:text-sm xl:text-lg">
              Discover experts' articles on signage trends, retail
              transformation, signage best practices, execution strategies and
              technology solutions that streamline brand campaigns.
            </p>
          </div>
        </div>
        <div className=" flex justify-center items-center">
          <img
            src="/assests/images/LandingPage/blogs/blogLandingImg.webp"
            alt="blog"
            className="w-full h-fit rounded-2xl"
          />
        </div>
      </div>
    </div>
  );
};

export default BlogsHero;
